module.exports = __webpack_public_path__ + "img/2022-01.9b326998.jpg";